'use strict';
const angular = require('angular');
const {element, isFunction} = angular;

module.exports = ['$provide',
  IonScrollDirectiveDecorator];

// inspired by https://gist.github.com/Zren/b5af94f2f81d65845d78
function IonScrollDirectiveDecorator($provide) {
  $provide.decorator('ionScrollDirective', [
    '$delegate',
    '$window',
    decorateService]);

  function decorateService($delegate, $window) {
    var ionScroll = $delegate[0];
    var sourceCompile = ionScroll.compile;
    ionScroll.compile = decoratedCompile;

    return $delegate;

    function decoratedCompile(iElement, iAttr) {
      var sourceCompileResult = sourceCompile(iElement, iAttr);
      var sourcePre = sourceCompileResult.pre;
      var sourcePost = sourceCompileResult.post;

      return {pre: sourcePre, post: decoratedPost};

      function decoratedPost($scope, $element, $attrs, ctrls) {
        if (isFunction(sourcePost)) sourcePost($scope, $element, $attrs, ctrls);

        if (ionic.Platform.isWebView()) return; // only alter scrolling behavior in web browser environment

        // we must lazily fetch the controller
        var scrollCtrl = $element.controller('$ionicScroll');
        if (!scrollCtrl) throw new Error('scrollBar must be attached to a $ionicScroll controller.');
        if (!scrollCtrl.scrollView.__indicatorY) return;

        var indicatorY = scrollCtrl.scrollView.__indicatorY.el;
        element(indicatorY).addClass('scroll-bar-track');

        var onDrag = $window.ionic.onGesture('drag', onDragGesture, indicatorY);
        var onTap = $window.ionic.onGesture('tap', onTapGesture, indicatorY);
        $element.on('wheel', onWheel);

        $scope.$on('$destroy', cleanup);

        function onDragGesture(e) {
          return scrollCtrl.scrollTo(0, scrollCtrl.scrollView.__scrollTop + e.gesture.deltaY);
        }

        function onTapGesture(e) {
          var bounds = indicatorY.getBoundingClientRect();
          var relY = e.gesture.center.pageY - bounds.top;
          var cursorY = relY / bounds.height * scrollCtrl.scrollView.options.getContentHeight();
          return scrollCtrl.scrollTo(0, cursorY);
        }

        function onWheel(e) {
          e.preventDefault();
          return scrollCtrl.scrollTo(0, scrollCtrl.scrollView.__scrollTop + e.deltaY);
        }

        function cleanup() {
          $window.ionic.offGesture(onDrag, 'drag', onDragGesture);
          $window.ionic.offGesture(onTap, 'tap', onTapGesture);
          $element.off('wheel', onWheel);
        }
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/js/core-utilities-implementation/ionic-delegates/IonScrollDirectiveDecorator.js